import { useTranslation } from 'react-i18next';

import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetTechniquesQuery } from '@api/technique.api';

export default function TechniqueSelector(props: MultiSelectProps) {
  const { t } = useTranslation();
  const { data = [], isLoading } = useGetTechniquesQuery();

  return (
    <MultiSelect
      label={t('selectors.techniquesUsed.label')}
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : t('selectors.techniquesUsed.placeholder')
      }
      data={data.map((technique) => ({
        label: technique.name,
        value: technique.name,
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
